module.exports = __webpack_public_path__ + "img/UT0360.c8bea938.png";